import { render } from "./VariationComponent.vue?vue&type=template&id=5fcc68b0"
import script from "./VariationComponent.vue?vue&type=script&lang=js"
export * from "./VariationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/VariationComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fcc68b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fcc68b0', __exports__)) {
    api.reload('5fcc68b0', __exports__)
  }
  
  module.hot.accept("./VariationComponent.vue?vue&type=template&id=5fcc68b0", () => {
    api.rerender('5fcc68b0', render)
  })

}


export default __exports__